import beyondTheBouncerContent from "../../../blogs/Beyond the Bouncer_ How Effective is IP Whitelisting in 2026_.md?raw";
import cliReauthContent from "../../../blogs/CLI Re-Authentication_ How Double O Keeps Your Scripts Running Without Exposing Secrets.md?raw";
import fromEnvToDoubleOContent from "../../../blogs/From .env to Double O_ The Next Evolution in Secrets Management.md?raw";
import hardcodedSecretsContent from "../../../blogs/Hardcoded Secrets vs. Runtime Injection_ Why Your API Keys Don't Belong in Your Code.md?raw";

export type BlogPost = {
  slug: string;
  title: string;
  description: string;
  publishedAt: string;
  readingTime: string;
  content: string;
};

export const blogPosts: BlogPost[] = [
  {
    slug: "cli-re-authentication-scripts-without-exposing-secrets",
    title:
      "CLI Re-Authentication: How Double O Keeps Your Scripts Running Without Exposing Secrets",
    description:
      "Learn how Double O's built-in re-auth flow lets you use short-lived tokens in scripts and CLI tools without operational friction.",
    publishedAt: "2026-03-08",
    readingTime: "7 min read",
    content: cliReauthContent,
  },
  {
    slug: "from-env-to-double-o-next-evolution-secrets-management",
    title: "From .env to Double O: The Next Evolution in Secrets Management",
    description:
      "Learn why .env files break down at scale and how Virtual .env brings secure sharing, easier rotation, and better auditability.",
    publishedAt: "2026-02-18",
    readingTime: "8 min read",
    content: fromEnvToDoubleOContent,
  },
  {
    slug: "hardcoded-secrets-vs-runtime-injection-api-keys",
    title:
      "Hardcoded Secrets vs. Runtime Injection: Why Your API Keys Don't Belong in Your Code",
    description:
      "See why hardcoded credentials create long-term exposure and how runtime secret injection reduces risk without slowing development.",
    publishedAt: "2026-01-30",
    readingTime: "9 min read",
    content: hardcodedSecretsContent,
  },
  {
    slug: "beyond-the-bouncer-ip-whitelisting-2026",
    title: "Beyond the Bouncer: How Effective is IP Whitelisting in 2026?",
    description:
      "An honest look at IP allowlisting strengths, weaknesses, and how layered controls make it practical for modern teams.",
    publishedAt: "2026-01-12",
    readingTime: "10 min read",
    content: beyondTheBouncerContent,
  },
];

export function getBlogPostBySlug(slug: string | undefined) {
  if (!slug) return undefined;
  return blogPosts.find(post => post.slug === slug);
}
